import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

import { NavArrow } from "./NavArrow";

import { pxToRem } from "@otta/design-tokens";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${pxToRem(24)};
`;

const CardsContainer = styled.div`
  display: flex;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  gap: ${pxToRem(4)};
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export function Carousel({ cards }: { cards: JSX.Element[] }) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [atCarouselStart, setAtCarouselStart] = useState(true);
  const [atCarouselEnd, setAtCarouselEnd] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (wrapperRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = wrapperRef.current;
        setAtCarouselStart(scrollLeft === 0);
        setAtCarouselEnd(scrollLeft === scrollWidth - clientWidth);
      }
    };

    wrapperRef.current?.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    return () => {
      wrapperRef.current?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    wrapperRef.current?.scrollTo?.(0, 0);
  }, [cards]);

  const handleNext = () => {
    wrapperRef.current?.scrollTo({
      left: wrapperRef.current.scrollLeft + wrapperRef.current.clientWidth,
      behavior: "smooth",
    });
  };

  const handlePrevious = () => {
    wrapperRef.current?.scrollTo({
      left: wrapperRef.current.scrollLeft - wrapperRef.current.clientWidth,
      behavior: "smooth",
    });
  };

  return (
    <Wrapper>
      <NavArrow
        onClick={handlePrevious}
        direction="left"
        displayArrow={!atCarouselStart}
        testId="previous-button"
      />
      <CardsContainer tabIndex={0} ref={wrapperRef}>
        {cards.map(card => card)}
      </CardsContainer>
      <NavArrow
        onClick={handleNext}
        direction="right"
        displayArrow={!atCarouselEnd}
        testId="next-button"
      />
    </Wrapper>
  );
}
